// extracted by mini-css-extract-plugin
export var buttonContainer = "_9l-1";
export var fontSizeSelect = "_9l-3";
export var formatSelect = "_9l-2";
export var formats = "_9l-4";
export var hidden = "_9l-5";
export var icon = "_9l-6";
export var select = "_9l-0";